import { Container, Form, Alert, Tab, Tabs} from 'react-bootstrap';
import {Sida,Rubrik,Stycke,Button,ContentWrapper} from "./ContentStyles";
import React, { useState ,useEffect, useReducer, fetchData, useMemo} from 'react';
import {MaterialReactTable, showRowExpandColumn} from 'material-react-table';
import testData from '../testData.json';

import useBackend, {CallAPI,  Spinner, UserData} from '../services/useBackend';

function Cities() {

  const {IsLoggedIn, token}      = UserData();

    const {loading, data, Refresh, Seek} =  useBackend(process.env.PUBLIC_URL+'/api/cities');
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
    const initialState = { density: 'compact', columnVisibility: { } };
    const state = { pagination };

    const columns = useMemo(() => [    
      { size: 40, accessorKey: 'name', header: 'City', enableColumnActions: false },
      { size: 40, accessorKey: 'guid', header: 'Guid', enableColumnActions: false },
    ]
  );

  if (!loading) {
  return (    
    <ContentWrapper>
    <Container>
      <Sida>
      <Rubrik>Städer</Rubrik>

        <MaterialReactTable columns={columns} data={data.cities} state={state} initialState={initialState}  
            onPaginationChange={setPagination} manualPagination= {false}  autoResetPageIndex= {false}
            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, 
            showRowExpandColumn: true, rowsPerPageOptions: [25, 50, 75, 100], labelRowsPerPage:"Rader" }}
        /> 
			</Sida>
		</Container>
		</ContentWrapper>
  );
} else {
      return (<Spinner />);        
  }   }

export default Cities;
